import PropTypes from 'prop-types';
import React from 'react';
import ButtonList, { ButtonListItem } from '@99designs/react-components/components/ButtonList';
import { getComponentClasses } from '@99designs/utils/app';

class StarRating extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hoveringIndex: 0,
        };

        this.isValidStarCount = this.isValidStarCount.bind(this);
        this.onStarClick = this.onStarClick.bind(this);
        this.onStarMouseEnter = this.onStarMouseEnter.bind(this);
        this.onStarMouseLeave = this.onStarMouseLeave.bind(this);
        this.getStarElement = this.getStarElement.bind(this);
        this.getStarElements = this.getStarElements.bind(this);
    }

    isValidStarCount(starCount) {
        return starCount > 0 && starCount <= this.props.numTotalStars;
    }

    onStarClick(startIndex) {
        var newStarCount = parseInt(startIndex, 10);
        var canChange =
            this.isValidStarCount(newStarCount) &&
            this.props.isEditable &&
            newStarCount !== this.props.numSelectedStars;
        var canUnrate =
            this.isValidStarCount(newStarCount) && newStarCount === this.props.numSelectedStars;

        if (canUnrate && this.props.onChange) {
            this.props.onChange({ rating: 0 });
            return;
        }

        if (canChange && this.props.onChange) {
            this.props.onChange({ rating: newStarCount });
            return;
        }
    }

    onStarMouseEnter(index) {
        this.setState({ hoveringIndex: index });
    }

    onStarMouseLeave() {
        this.setState({ hoveringIndex: 0 });
    }

    getStarElement(numSelectedStars, starIndex) {
        var starVariations = [];
        var starClasses;

        if (numSelectedStars >= starIndex) {
            starVariations.push('selected');
        } else if (this.props.isEditable && this.state.hoveringIndex >= starIndex) {
            starVariations.push('hovered');
        } else {
            starVariations.push('unselected');
        }

        if (!this.props.isEditable) {
            starVariations.push('disabled');
        }

        starClasses = getComponentClasses(
            'rating-star',
            starVariations.concat(this.props.starVariations)
        );

        return (
            <button
                className={starClasses}
                onClick={this.onStarClick.bind(this, starIndex)}
                onMouseEnter={this.onStarMouseEnter.bind(this, starIndex)}
                onMouseLeave={this.onStarMouseLeave}
            />
        );
    }

    getStarElements(numSelectedStars, numTotalStars) {
        var elements = [];

        if (numSelectedStars > numTotalStars) {
            numSelectedStars = numTotalStars;
        }

        for (var i = 1; i <= numTotalStars; i++) {
            elements.push(
                <ButtonListItem key={'star' + i}>
                    {this.getStarElement(numSelectedStars, i)}
                </ButtonListItem>
            );
        }

        return elements;
    }

    render() {
        var stars = this.getStarElements(this.props.numSelectedStars, this.props.numTotalStars);

        return <ButtonList variations={['compact']}>{stars}</ButtonList>;
    }
}

StarRating.defaultProps = {
    isEditable: false,
    numTotalStars: 5,
    numSelectedStars: 0,
    starVariations: [],
};

StarRating.propTypes = {
    isEditable: PropTypes.bool,
    numSelectedStars: PropTypes.number,
    numTotalStars: PropTypes.number,
    onChange: PropTypes.func,
    starVariations: PropTypes.array,
};

export default StarRating;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/star-rating.jsx